export const stringToBoolean = (str: string | null | undefined) => {
  if (!str) {
    return false;
  }
  if (typeof str === 'string') {
    return !['0', 'false', 'no', 'n', 'null', 'undefined', 'nil'].includes(str.toLowerCase().trim());
  }
  return Boolean(str);
}
